// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"ae43618b","241":"a8f0aafe","271":"e7ecdb95","848":"0ef8461f"}[chunkId] + ".chunk.css";
};